// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const wrapperStyles = () => {
    return css`
        padding-bottom: ${x => x.theme.design.typography.spacing.large};
        margin-right: ${pxToRem(60)};
        flex-direction: column;
        width: 100%;
    `;
};

export const specStyles = (unit?: string | undefined, unitNumber?: number | undefined) => {
    return css`
        font-weight: ${x => x.theme.design.typography.weight.bold};
        ${unitNumber !== undefined
            ? css`
                  margin: ${x => x.theme.design.typography.spacing.base} ${unitNumber};
              `
            : css`margin-${unit}: ${x => x.theme.design.typography.spacing.base};`}
    `;
};

export const specificationWrapperStyles = () => {
    return css`
        width: 100%;
        display: flex;
        padding-bottom: ${pxToRem(23)};
    `;
};

export const attributeTypeValuesTextStyles = () => {
    return css`
        display: flex;
        flex-direction: column;
        border-top: ${pxToRem(1.5)} solid ${getColor("common.border")};
        padding: ${x => x.theme.design.typography.spacing.small};
        word-break: normal;
        width: 100%;
        &:last-child {
            border-bottom: ${pxToRem(1.5)} solid ${getColor("common.border")};
            padding: ${x => x.theme.design.typography.spacing.small};
        }
    `;
};

export const attributeTypeLabelTextStyles = () => {
    return css`
        word-wrap: normal;
        word-break: normal;
    `;
};

export const attributeValuesTextStyles = () => {
    return css`
        font-weight: ${x => x.theme.design.typography.weight.bold};
    `;
};
